import React from 'react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Cómo ayudar a tu hijo a leer mejor',
    image: 'https://cdn.magicpatterns.com/uploads/sCFuecrYQeDo6TM9txg7M6/bonus_1.png',
    bullets: ['cómo despertar el interés por la lectura', 'técnicas para mejorar comprensión', 'estrategias simples para acompañar']
  }, {
    id: 2,
    title: 'Cómo desarrollar el pensamiento matemático',
    image: 'https://cdn.magicpatterns.com/uploads/qavqcjyGgoE6QfHCL62grm/bonus_2.png',
    bullets: ['actividades para estimular el razonamiento', 'juegos para desarrollar lógica', 'formas simples de aprender matemáticas']
  }, {
    id: 3,
    title: 'Pequeños cuentos para grandes pensamientos',
    image: 'https://cdn.magicpatterns.com/uploads/ggCb49yRFntMsjmrdGjAi4/bonus_3.png',
    bullets: ['estimulan reflexión y comprensión', 'desarrollan imaginación', 'fortalecen pensamiento crítico']
  }];
  return <section className="w-full bg-white py-14 px-4 border-t border-gray-200" data-id="element-42">
      <div className="max-w-2xl mx-auto text-center" data-id="element-43">
        <h2 className="text-3xl md:text-4xl font-black text-black mb-2" data-id="element-44">
          🎁 Bonos incluidos hoy
        </h2>
        <p className="text-xl font-bold text-red-600 mb-12" data-id="element-45">
          (sin costo adicional)
        </p>

        <div className="space-y-16" data-id="element-46">
          {bonuses.map(bonus => <div key={bonus.id} className="text-center" data-id="element-47">
              <p className="text-lg font-black text-red-600 uppercase tracking-widest mb-4" data-id="element-48">
                🎁 Bono {bonus.id}
              </p>

              <h3 className="text-2xl md:text-3xl font-black text-black mb-6" data-id="element-49">
                {bonus.title}
              </h3>

              <a href="#compra" className="block max-w-xs mx-auto mb-8" data-id="element-50">
                <img src={bonus.image} alt={bonus.title} className="w-full aspect-square object-contain" data-id="element-51" />
              </a>

              <ul className="text-left max-w-md mx-auto space-y-3 text-lg font-bold text-gray-800" data-id="element-52">
                {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start" data-id="element-53">
                    <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-54">✓</span>
                    {bullet}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}